export const APP_CONFIG_QUERY_KEY = ['appConfig'] as const;
export const COURSE_FORM_OPTIONS_QUERY_KEY = ['courseFormOptions'] as const;
